import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'es_AR',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'ab9d57d0-5e9b-4185-8a79-fcaf652c78af',
  ''
);
